import { useAbGroup } from '@/app/providers/ConfigProvider';
import { AB_GROUP_COOKIE_KEY } from '@/app/utils/abTesting/checkout-form';
import { edges, getProjectDetailGroup, ProjectDetailGroup } from '@/app/utils/abTesting/project-detail';
import { useState } from 'react';

export const CookieDevtool = () => {
  const abGroup = useAbGroup();
  const group = getProjectDetailGroup(parseInt(abGroup));
  const [open, setOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const handleClick = (group: ProjectDetailGroup) => {
    // set cookie
    document.cookie = `${AB_GROUP_COOKIE_KEY}=${edges[group][0]}; path=/`;
    window.location.reload();
  };

  if (isHidden) {
    return null;
  }

  return (
    <div className="fixed z-[990] left-[16px] top-[16px] bg-[rgba(0,0,0,0.5)] text-white px-[8px]  rounded-lg shadow-lg flex flex-col justify-center items-center">
      <strong>{group}</strong>
      <div className="mb-[8px]" onClick={() => setOpen(!open)}>
        {open ? 'Close' : 'Open'}
      </div>

      {open && (
        <>
          {open &&
            Object.values(ProjectDetailGroup).map((group) => (
              <div key={group} onClick={() => handleClick(group)}>
                {group}
              </div>
            ))}

          <div className="mt-[8px]" onClick={() => setIsHidden(true)}>
            {isHidden ? 'Show' : 'Hide'}
          </div>
        </>
      )}
    </div>
  );
};
